import React, { Component } from 'react'
import { connect } from 'react-redux'
import ServiceDrawer from '../components/ServiceDrawer'
import ServiceActions from '../redux/serviceRedux'
import LayerActions from '../redux/layerRedux'
import MapActions from '../redux/mapRedux'
import DataActions from '../redux/dataRedux'
import NotificationActions from '../redux/notificationRedux'
import { withErrorBoundary } from '../errors/ErrorBoundary'

class ServiceNavigation extends Component {
  componentDidMount = () => {
    const { serviceCardActive, actions } = this.props

    if (serviceCardActive) {
      actions.serviceCardMounted(serviceCardActive)
    }
  }
  
  render () {
    const {
      actions,
      authenticated,
      serviceDrawerOpen,
      layersRendered,
      serviceCardActive,
      services
    } = this.props

    if (!authenticated) {
      return null
    }
    
    return (
      <ServiceDrawer
        open={serviceDrawerOpen}
        handleClose={actions.serviceDrawerClosed}
        handleLayerToggled={actions.layerRenderToggled}
        handleLocationClicked={actions.centerChanged}
        layersRendered={layersRendered}
        serviceCardActive={serviceCardActive}
        serviceCardChanged={actions.serviceCardChanged}
        serviceCardClicked={false}
        services={services}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.login.authenticated,
    layersRendered: state.layer.layersRendered,
    serviceCardActive: state.service.serviceCardActive,
    serviceDrawerOpen: state.service.serviceDrawerOpen,
    services: state.service.services
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      layerRenderToggled: name =>
        dispatch(LayerActions.layerRenderToggled(name)),
      serviceCardChanged: service => {
        dispatch(ServiceActions.serviceCardChanged(service))
        dispatch(DataActions.dataRequested(service))
      },
      serviceCardMounted: service => dispatch(NotificationActions.serviceCardMounted(service)),
      serviceDrawerClosed: () => dispatch(ServiceActions.serviceDrawerClosed()),
      centerChanged: (center, zoom, maxBounds, name) => {
        dispatch(MapActions.maxBoundsCenterZoomChanged(maxBounds, center, zoom))
        dispatch(ServiceActions.locationSelectedChanged(name))
      }
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(ServiceNavigation))



// WEBPACK FOOTER //
// ./src/containers/ServiceNavigation.js